import React from 'react';

export default function SkipLinks() {
  return (
    <nav aria-label="Skip navigation" className="skip-links">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <a href="#navigation" className="skip-link">Skip to navigation</a>
    </nav>
  );
}
